import { CONFIG } from '@gallaghercp/core-frontend';

export const APP_CONFIG: CONFIG = {
    appName: 'Calix Candidate',
    frontend: 'https://calix-candidate.mybenefitsnow.com',
    apiHash: 'https://calix-candidate.mybenefitsnow.com/api/1.0',
    api: '/api/2.0',
    trustModel: false,
    authHeaders: {
        xServiceProvider: 'calix-candidate-prod-frontend',
        'tenant-id': '82b81f88-a041-4528-b9d6-91b1592de572',
        'consumer-id': 'bad58975-ec44-442d-832e-f4d7ecad34da',
    },
    cookiePolicy: 'e2b1417b',
    commitSHA: '1664030',
    provider: 'calix-candidate-prod-frontend',
    gtm: 'GTM-P524NZZX',
showNotifications: false,
    multilingual: false,
    colors: {
        primary: '#0b38db',
        secondary: '#ff7600',
    },
    readabilityEnabled: false,
    articlesParentRoute: 'news',
    imagery: {
        logo: 'https://storage.googleapis.com/archipelago-assets/calix-logo.png',
        logoInverted: 'https://storage.googleapis.com/archipelago-assets/calix-logo.png',
        logoTransparent: 'https://storage.googleapis.com/archipelago-assets/calix-logo.png',
    },
    copyright: '&copy; ' + new Date().getFullYear() + ' Gallagher. All Rights Reserved.' + ' Powered by Core.',
    demoMode: false,
    chatEnabled: false,
    contactEnabled: false,
    isDarkModeEnabled: false,
    postsLabel: 'news',
    coreLinkify: true,
    navigation: {
        navType: 'top',
        headerStyle: 'solid',
        style: 'default',
        categoryNav: false,
        navigationOrder: 'displayOrder',
    },
    pwa: {
        enabled: false,
        notifications: false,
    },
    enableSSR: false,
} as CONFIG; 
